import { isObject } from '@principle-theorem/shared';
import { isString } from 'lodash';

export interface IEmailTrackingTokenData {
  trackingUid: string;
}

export function isEmailTrackingTokenData(
  data: unknown
): data is IEmailTrackingTokenData {
  return isObject(data) && isString(data.trackingUid);
}
